module.exports = __webpack_public_path__ + "static/media/fig_3a.0a82bc06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_3a.jpg
// module id = 673
// module chunks = 0